
import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Table, Input, FormGroup, Label, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import UiContent from "../../../../Components/Common/UiContent";
import BetterStandsContext from "../../../../Components/Contexts/Management/BetterStandsContext";
import axios from 'axios';
import {EXTERNAL_IMAGE_PATH} from "../../../../Components/Contexts/BackendConstants";
import { useTranslation } from "react-i18next";
import i18n from "../../../../i18n";

const tableStyles = {
    tableResponsive: {
        overflowX: 'auto',
        width: '100%'
    },
    table: {
        width: '100%'
    },
    cell: {
        wordBreak: 'break-word',
        maxWidth: '200px'
    }
};

const AcilDurumDOF = () => {
  const { t } = useTranslation("saha");
    useEffect(() => { document.title = i18n.t("saha:acilDurumDof.acilDurumDof"); }, []);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [dofItems, setDofItems] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDof, setSelectedDof] = useState(null);
    const { fetchActiveFairId, activeFairId } = useContext(BetterStandsContext);


    const fetchDofItems = async () => {
        setLoading(true);
        try {
            const payload = {
                fuar_id: activeFairId,
                start: 0,
                length: 1000,
                search: {
                    value: searchTerm,
                    regex: false
                },
                form_level_id: 4, // Changed to 4 for DOF
                form_type_id: 5,
                form_salon_id: 0,
                draw: 1,
                columns: Array(10).fill({
                    data: 0,
                    name: null,
                    searchable: true,
                    orderable: true,
                    search: {
                        value: null,
                        regex: false
                    }
                })
            };
            payload.order = [{'column': 8, 'dir': 'desc' }];

            const response = await axios.post('https://fds.sakagrup.com/FormSystem/xFormListeBS/3', payload, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
            });
            setDofItems(response.data.data);
        } catch (error) {
            console.error("Error fetching DOF items:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const initializePage = async () => {
            setLoading(true);
            try {
                const userId = localStorage.getItem('userId');
                if (!userId) { console.error("User ID not found in localStorage"); return; }
                await fetchActiveFairId(userId);
            } catch (error) {
                console.error("Error initializing page:", error);
            } finally { setLoading(false); }
        };
        initializePage();
    }, [fetchActiveFairId]);

    useEffect(() => {
        if (activeFairId) {
            async function run() { await fetchDofItems(); }
            run();
        }
    }, [activeFairId, searchTerm]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const openDetailModal = (dof) => {
        setSelectedDof(dof);
        setModalOpen(true);
    };

    const closeDetailModal = () => {
        setSelectedDof(null);
        setModalOpen(false);
    };

    return (
        <React.Fragment>
            <UiContent />
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("acilDurumDof.acilDurumDof2")} pageTitle={t("acilDurumDof.acilDurum")} />
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title mb-4">{t("acilDurumDof.dofListesi")}</h4>
                                    <FormGroup className="mb-3">
                                        <Label for="searchInput">{t("common:ara")}</Label>
                                        <Input
                                            id="searchInput"
                                            type="text"
                                            value={searchTerm}
                                            onChange={handleSearch}
                                            placeholder={t("acilDurumDof.ara")}
                                        />
                                    </FormGroup>
                                    {loading ? (
                                        <p>{t("common:yukleniyor")}</p>
                                    ) : dofItems.length === 0 ? (
                                        <p>{t("acilDurumDof.hicDofBulunamadi")}</p>
                                    ) : (
                                        <div style={tableStyles.tableResponsive}>
                                            <Table className="table align-middle table-nowrap" style={tableStyles.table}>
                                                <thead>
                                                <tr>
                                                    <th>{t("acilDurumDof.id")}</th>
                                                    <th>{t("acilDurumDof.dof")}</th>
                                                    <th>{t("acilDurumDof.firmaStant")}</th>
                                                    <th>{t("acilDurumDof.denetmen")}</th>
                                                    <th>{t("acilDurumDof.islem")}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {dofItems.map((dof) => (
                                                    <tr key={dof[0]}>
                                                        <td style={tableStyles.cell}>{dof[0]}</td>
                                                        <td style={tableStyles.cell}>
                                                            <div><strong>{t("acilDurumDof.formTuru")}</strong> {dof[2]}</div>
                                                            <div><strong>{t("acilDurumDof.konu")}</strong> {dof[3]}</div>
                                                            <div style={{ overflow: "hidden" }}><strong>{t("acilDurumDof.tehlike")}</strong> {dof[4]}</div>
                                                        </td>
                                                        <td style={tableStyles.cell}>
                                                            <div style={{ overflow: "hidden" }}><strong>{t("acilDurumDof.firma")}</strong>{dof[5]}</div>
                                                            <div><strong>{t("acilDurumDof.stant")}</strong>{dof[6]}</div>
                                                        </td>
                                                        <td style={tableStyles.cell}>
                                                            <div style={{ overflow: "hidden" }}><strong>{t("acilDurumDof.kullanici")}</strong>{dof[7]}</div>
                                                            <div><strong>{t("acilDurumDof.olusturulma")}</strong>{dof[8]}</div>
                                                        </td>
                                                        <td style={tableStyles.cell}>
                                                            <Button color="primary" onClick={() => openDetailModal(dof)}>
                                                                {t("common:detay")}
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={modalOpen} toggle={closeDetailModal} size="lg">
                <ModalHeader toggle={closeDetailModal}>{t("acilDurumDof.dofDetayi")}</ModalHeader>
                <ModalBody>
                    {selectedDof && (
                        <div>
                            <p><strong>{t("acilDurumDof.id2")}</strong> {selectedDof[0]}</p>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                {Array.isArray(selectedDof[1]) && selectedDof[1].map((photo, index) => (
                                    <div key={index} style={{ flexBasis: 'calc(50% - 5px)' }}>
                                        {photo.saha_form_photo_link && (
                                            <img
                                                src={EXTERNAL_IMAGE_PATH+photo.saha_form_photo_link}
                                                alt={t("acilDurumDof.dofPhoto", { v: index + 1 })}
                                                style={{width: '100%', height: 'auto', objectFit: 'cover'}}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                            <p><strong>{t("acilDurumDof.formTuru2")}</strong> {selectedDof[2]}</p>
                            <p><strong>{t("acilDurumDof.konu2")}</strong> {selectedDof[3]}</p>
                            <p><strong>{t("acilDurumDof.tehlike2")}</strong> {selectedDof[4]}</p>
                            <p><strong>{t("acilDurumDof.firma2")}</strong> {selectedDof[5]}</p>
                            <p><strong>{t("acilDurumDof.standNo")}</strong> {selectedDof[6]}</p>
                            <p><strong>{t("acilDurumDof.denetmen2")}</strong> {selectedDof[7]}</p>
                            <p><strong>{t("acilDurumDof.olusturulmaTarihi")}</strong> {selectedDof[8]}</p>
                            {/* Add more details as needed */}
                        </div>
                    )}
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default AcilDurumDOF;